import styled from "styled-components";
import OkoAniMouth from "assets/OKO_AniMouth_HigherRez.gif";
import OKOCharacter from "assets/OKO_op2_yellow.svg";
import OKOCharacterNoMouth from "assets/OKO_op2_yellow2.svg";
import OKOCharacterShadow from "assets/Shadow.svg";
import { SpeechBubble } from "components/shared/SpeechBubble/SpeechBubble";
import { motion } from "framer-motion";

export const OkoAssistant = ({
  isPlayingAudio,
  phrase,
  setShowText,
  showText,
  positionLeft,
  positionBottom,
  arrowDirection,
  speechTextMinWidth,
  maxLength,
}) => {

  const okoCharacter = isPlayingAudio ? OKOCharacterNoMouth : OKOCharacter;

  return (
    <Container>
      <CharacterContainer>
        <Wrapper showText={showText} onClick={() => setShowText(true)}>
          <img src={okoCharacter} style={{ width: "136px", zIndex: 10 }} alt="character" />
          <img src={OKOCharacterShadow} style={{ position: "relative", top: "-10px", width: "136px" }} alt="shadow" />
          <Mouth isPlayingAudio={isPlayingAudio} okoAniMouth={OkoAniMouth} />
        </Wrapper>
        {phrase && showText && (
          <SpeechBubble
            minWidth={speechTextMinWidth}
            text={phrase}
            hide={!showText}
            setDisplay={setShowText}
            positionLeft={positionLeft}
            positionBottom={positionBottom}
            arrowDirection={arrowDirection}
            maxLength={maxLength}
          />
        )}
      </CharacterContainer>
    </Container>
  );
};

const Mouth = styled.div`
  background-image: url(${({ isPlayingAudio, okoAniMouth }) => isPlayingAudio ? okoAniMouth : "none"});
  width: 68px;
  height: 68px;
  left: 38px;
  top: 37px;
  border-radius: 100px;
  position: absolute;
  background-size: cover;
  z-index: 10;
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 275px;
  width: 317px;
  z-index: 10010;
`

const Wrapper = styled(motion.div)`
  align-items: center;
  display: grid;
  justify-content: center;
  width: 136px;
  height: 136px;
  transform: ${({ showText }) => showText ? "scale(1)" : "scale(0.4)"};
  transition: transform 0.3s ease-in-out;
  cursor: ${({ showText }) => showText ? "default" : "pointer"};
`

const CharacterContainer = styled.div`
  position: absolute;
  display: flex;
  left: 24px;
  bottom: 24px;
`;
